import React from 'react';

export default function DarkVenueHeatmapHelpText() {
    return (
        <>
            <div>
                This heatmap widget provides a view across dark liquidity for a
                selected symbol using Instinet&apos;s proprietary dark liquidity
                fingerprinting model. The heatmap is updated every 15 minutes.
            </div>
            <div>
                Liquidity is expressed as a % of total reported dark liquidity.
            </div>
        </>
    );
}
